import { useEffect, useState } from "react";
import { fetchIntegrationLogs } from "../../services/integrationService";
import { IIntegrationData, IIntegrationResponse, IntegrationLogFilters } from "../../interfaces/IIntegrationData";
import PaginationComponent from "../../components/UIElements/Pagination/Pagination";
import { ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import { set } from "react-datepicker/dist/date_utils";

const Integrations = () => {
  const location = useLocation();
  const MIN_ITEMS = parseInt(sessionStorage.getItem("itemsPerPage") || "10");

  const [logs, setLogs] = useState<IIntegrationResponse>();
  const [isLoading, setIsLoading] = useState(true);
  const [itemsPerPage] = useState(MIN_ITEMS);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchLogs = async (pageNumber: number = 1) => {

  setIsLoading(true);
  const filters: IntegrationLogFilters = {
    pageSize: itemsPerPage,
    pageNumber: currentPage
  };
  const data = await fetchIntegrationLogs(filters);
  setLogs(data);
  setIsLoading(false);
  setCurrentPage(data.PageNumber);
  setTotalPages(data.TotalPages);
};

  useEffect(() => {
    fetchLogs();
  }, []);

    const handlePageChange = (pageNumber: number) => {
    fetchLogs(pageNumber);
  };

  return (
    <div>
      <div className="page-title">
        <p>Integration Logs</p>
      </div>

      {isLoading ? (
        <p>Loading...</p>
      ) : logs?.Logs.length === 0 ? (
        <p>No logs available.</p>
      ) : (
        <div className="container-fluid mt-2">
        <table className="table table-hover">
          <thead>
            <tr>
              <th className="th">Time</th>
              <th className="th">Integration</th>
              <th className="th">Status</th>
              <th className="th">Description</th>
            </tr>
          </thead>
          <tbody>
            {logs?.Logs.map((Log) => (
              <tr key={Log.Id}>
                <td>{new Date(Log.LogTimeStamp).toLocaleString()}</td>
                <td>{Log.IntegrationName}</td>
                <td>{Log.Status}</td>
                <td>{Log.Description}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <PaginationComponent
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          closeOnClick={false}
          pauseOnHover
          draggable
          theme="light"
        />
        </div>
      )}
    </div>
  );
};

export default Integrations;
